<template>
  <div>
    <!-- {{ selectedItem }} -->
    <div>
      <!-- seleccionar franja -->
      <v-row>
        <v-col
          cols="12"
          md="5"
        >
          <koiote-date-picker
            :dateLabel="'Fecha Inicio'"
            :hourLabel="'Hora Inicio'"
            :type="1"
          ></koiote-date-picker>
        </v-col>
        <v-col
          cols="12"
          md="5"
        >
          <koiote-date-picker
            :dateLabel="'Fecha Fin'"
            :hourLabel="'Hora Fin'"
            :type="2"
          ></koiote-date-picker>
        </v-col>
        <v-col
          cols="12"
          md="2"
          class="d-flex align-self-center"
        >
          <v-btn
            block
            @click="buscar()"
            >Buscar</v-btn
          >
        </v-col>
      </v-row>
    </div>
    <!-- Grafico de estados -->
    <div style="position: relative; width: 100vw; height: 100vw">
      <canvas
        ref="myCanvas"
        style="position: absolute; z-index: 1; left: 60%; transform: translateX(-50%)"
      ></canvas>
      <canvas
        ref="datosCanvas"
        style="position: absolute; z-index: 2; pointer-events: none; left: 60%; transform: translateX(-50%)"
      ></canvas>
      <!-- Grafico de procentajes -->
      <canvas
        ref="canvasTitulo"
        style="position: absolute; z-index: 2; top: 330px; left: 45%; transform: translateX(-50%)"
      ></canvas>
      <canvas
        ref="canvasPorcentaje"
        style="position: absolute; z-index: 1; top: 350px; left: 60%; transform: translateX(-50%)"
      ></canvas>
      <canvas
        ref="datosCanvasPorcentaje"
        style="position: absolute; z-index: 2; top: 350px; pointer-events: none; left: 60%; transform: translateX(-50%)"
      ></canvas>
      <!-- label -->
      <canvas
        ref="canvasLabel"
        style="position: absolute; z-index: 3; top: 450px; left: 80%; transform: translateX(-50%)"
      ></canvas>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import moment from "moment-timezone";
import { mapState, mapActions } from "vuex";
import KoioteDatePicker from "@/components/utils/KoioteDatePicker.vue";

export default {
  props: {
    input: Object,
  },
  components: {
    KoioteDatePicker,
  },
  data() {
    return {
      //array para cada cuadrado creado en el grafico de estados
      estados: [],
      //booleano para saber si hay inicio especial
      inicioFueraIntervalo: false,
      //array para cada cuadrado creado en el grafico de porcentajes
      porcentajes: [],
      //array con los datos del historico de estados
      dataEstados: [],
      //array con los distintos estados que puede tener la maquina
      estadosActivos: [],
      //variable para guardar el ultimo estado del array
      ultimoEstado: null,
      datosCargados: false,
    };
  },
  computed: {
    ...mapState(["selectedItem"]),
    ...mapState("utils", ["init_date_filter", "end_date_filter"]),
    //Filtro fechas
    //--------------------------------------------------------------------
    //fecha de inicio dada por el usuario
    fechaInicio() {
      return this.input.customized.fechaInicio;
    },
    //hora de inicio dada por el usuario
    horaInicio() {
      return this.input.customized.horaInicio;
    },
    //fecha de final dada por el usuario
    fechaFin() {
      return this.input.customized.fechaFin;
    },
    //hora de final dada por el usuario
    horaFin() {
      return this.input.customized.horaFin;
    },
    //Tipo de eje X dado por el usuario
    //-------------------------------------------------------------------------
    idEjeX() {
      return this.input.customized.tipoEjeX;
    },
  },
  methods: {
    ...mapActions(["getData"]),
    // ...mapActions("utils", ["setInitDateFilter", "setEndDateFilter"]),
    //funcion que recoge de la base de datos los datos correspondientes a los estados de la maquina
    //-----------------------------------------------------------------------------------------------------------------------------
    async getDataEstados() {
      // console.log("recogiendo datos de la bdd");
      try {
        const response = await this.getData({
          path: "variables/history/estados",
          params: {
            variables: 1,
            initDate: moment(this.init_date_filter).format("YYYY-MM-DD HH:mm:ss"),
            endDate: moment(this.end_date_filter).format("YYYY-MM-DD HH:mm:ss"),
          },
        });
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    //Funcion para evitar datos consecutivos iguales (Preprocesamiento)
    //----------------------------------------------------------------------------------------------------------------------------------------
    preprocesamientoDeDatos() {
      let valorAnterior = 0;
      for (let i = 0; i <= this.dataEstados.length - 1; i++) {
        // console.log(valorAnterior, this.dataEstados[i].value);
        if (valorAnterior == this.dataEstados[i].value) {
          // console.log("eliminar");
          this.dataEstados.splice(i, 1);
          //como eliminamos un elemento, volvemos una posicion atras
          i--;
        } else {
          // console.log("actualizar");
          valorAnterior = this.dataEstados[i].value;
        }
      }
    },

    async buscar() {
      // console.log("buscando");
      //recogida de los datos
      this.dataEstados = await this.getDataEstados();

      this.datosCargados = true;

      //preprocesamiento de los datos
      this.preprocesamientoDeDatos();
      this.estadosActivos = [];
      //recogida de los posibles estados
      // if (this.estadosActivos.length === 0) {
      let nombreEstados = [];
      if (this.selectedItem !== null) {
        this.dataEstados.forEach((Element) => {
          if (!nombreEstados.includes(Element.value)) {
            nombreEstados.push(Element.value);
          }
        });
        // console.log(nombreEstados);
        nombreEstados.forEach((element) => {
          this.estadosActivos.push({
            nombre: element,
            color: this.generarColor(element),
            checked: true,
          });
        });
      }
      // }
      // this.estadosActivos = this.input.customized.estados;

      console.log(this.dataEstados);
      //generacion del grafico
      if (this.dataEstados.length !== 0) {
        this.generarGraficoEstados();
        this.generarGraficoPorcentajes();
        this.generarLabelGraficos();
        this.generarTituloGraficos();
      }
    },
    //funcion para actualizar el recuadro de datos
    //----------------------------------------------------------------------------------------------------------------------------------
    updateHoverCanvas(xMouse, yMouse, componente, hoverCanvas, hoverCtx) {
      hoverCtx.clearRect(0, 0, hoverCanvas.width, hoverCanvas.height);

      hoverCtx.fillStyle = "rgba(128, 128, 128, 0.6)";
      hoverCtx.fillRect(xMouse, yMouse, 170, 80);

      hoverCtx.fillStyle = "black";
      hoverCtx.font = "bold 15px Arial";
      hoverCtx.fillText("Estado: " + this.generarNombre(componente.estado), xMouse + 10, yMouse + 25);
      hoverCtx.fillText("Hora Inicio: " + componente.horaInicio, xMouse + 10, yMouse + 50);
      hoverCtx.fillText("Hora Fin: " + componente.horaFin, xMouse + 10, yMouse + 75);
    },
    updateHoverCanvasPorcentaje(xMouse, yMouse, componente, hoverCanvas, hoverCtx) {
      hoverCtx.clearRect(0, 0, hoverCanvas.width, hoverCanvas.height);

      hoverCtx.fillStyle = "rgba(128, 128, 128, 0.6)";
      hoverCtx.fillRect(xMouse, yMouse, 170, 80);

      hoverCtx.fillStyle = "black";
      hoverCtx.font = "bold 15px Arial";
      hoverCtx.fillText("Estado: " + this.generarNombre(componente.estado), xMouse + 10, yMouse + 25);
      hoverCtx.fillText("Porcentaje: " + Math.round(componente.porcentaje) + "%", xMouse + 10, yMouse + 40);
      hoverCtx.fillText("Tiempo: " + this.segundosAminutos(componente.total), xMouse + 10, yMouse + 55);
      console.log(componente);
    },
    segundosAminutos(duration) {
      // Hours, minutes and seconds
      var hrs = ~~(duration / 3600);
      var mins = ~~((duration % 3600) / 60);
      var secs = ~~duration % 60;

      // Output like "1:01" or "4:03:59" or "123:03:59"
      var ret = "";

      if (hrs > 0) {
        ret += "" + hrs + "h " + (mins < 10 ? "0" : "");
      }

      ret += "" + mins + "min " + (secs < 10 ? "0" : "");
      ret += "" + secs + "s";
      return ret;
    },
    //Funcion para generar el grafico de estados
    //----------------------------------------------------------------------------------------------------------------------------------
    generarGraficoEstados() {
      // console.log("generando grafico");
      //vaciar variables para cada ejecucion
      this.inicioFueraIntervalo = false;
      this.estados = [];
      this.ultimoEstado = this.dataEstados[this.dataEstados.length - 1];
      //creacion del canfas
      const canvas = this.$refs.myCanvas;
      const ctx = canvas.getContext("2d");

      //cogemos el width y height que viene desde el dragable
      canvas.width = this.input.customized.width * 9.5 + 1000;
      canvas.height = this.input.customized.height * 9.5;

      const hoverCanvas = this.$refs.datosCanvas;
      const hoverCtx = hoverCanvas.getContext("2d");

      hoverCanvas.width = canvas.width;
      hoverCanvas.height = canvas.height / 1.5;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      //altura del grafico de estados
      const alturaCubo = canvas.height / (this.idEjeX == 1 ? 2 : 3);

      //punto donde dejar los cubos del estado en el eje Y---> siempre constante
      const posY = 10; //this.input.y

      //punto donde dejar los cubos del estado en el eje X---> varia dependiendo cuanto tiempo transcurre en cada estado
      let posX = 0; //this.input.x
      // let posXAnt = 0;

      // let difAnt = 0;
      // if (this.fechaInicio !== null && this.fechaFin !== null && this.horaInicio !== null && this.horaFin !== null) {
      //horas dadas por el usuario dentro de un unico estado, condicion especial
      //Condicion especial del grafico
      //-------------------------------------------------------------------------------------------------------------------------------
      if (this.dataEstados.length === 1) {
        // console.log("condicion especial");
        const estadoEspecial = this.dataEstados[0];
        const estadoActivo = this.estadosActivos.find((estado) => estado.nombre === estadoEspecial.value);
        const color = estadoActivo.checked ? this.getColor(estadoEspecial.value) : "#ffffff";

        //generar el estado que ocupara todo el grafico
        ctx.fillStyle = color; //this.getColor(this.dataEstados[i-1].marcha);
        ctx.fillRect(posX, posY, canvas.width - 500, alturaCubo);

        const horaInicioEstado = moment(this.dataEstados[0].read_at).format("HH:mm:ss");
        const horaFinEstado = moment
          .utc(this.end_date_filter, "YYYY-MM-DD HH:mm:ss")
          .tz(moment.tz.guess())
          .format("HH:mm:ss");

        const dif = moment(this.end_date_filter).diff(this.init_date_filter, "seconds");

        //generar los labels con las horas
        //hora inicio
        this.generarEjeX(
          ctx,
          canvas,
          posX,
          posY,
          alturaCubo,
          moment.utc(this.init_date_filter, "YYYY-MM-DD HH:mm:ss").tz(moment.tz.guess()).format("YYYY-MM-DD HH:mm:ss")
        );

        //hora final
        this.generarEjeX(
          ctx,
          canvas,
          canvas.width - 500,
          posY,
          alturaCubo,
          moment.utc(this.end_date_filter, "YYYY-MM-DD HH:mm:ss").tz(moment.tz.guess()).format("YYYY-MM-DD HH:mm:ss")
        );

        this.estados.push({
          x: posX,
          y: posY,
          width: canvas.width - 500,
          height: alturaCubo,
          total: dif,
          horaInicio: `${horaInicioEstado}`,
          horaFin: `${horaFinEstado}`,
          estado: this.dataEstados[0].value,
          color: this.getColor(this.dataEstados[0].value),
        });
      }
      //ejecucion normal
      //----------------------------------------------------------------------------------------------------------------------------------------------
      else {
        //Cogemos el tiempo total y lo escalamos adecuandolo al width del canvas
        const tiempoTotal = moment(this.end_date_filter).diff(this.init_date_filter, "seconds"); //this.calcularTiempoTotal();
        // console.log(tiempoTotal);
        const refactor = (canvas.width - 500) / tiempoTotal;
        // console.log(refactor);
        //Inicio especial del grafico, si la hora de inicio esta dentro de un intervalo de tiempo de un estado
        // -----------------------------------------------------------------------------------------------------------------------------------------------
        // if (this.inicioFueraIntervalo) {
        //estadoInicio es el estado que tiene dentro horaInicio
        let estadoInicio = this.dataEstados[0];
        //estadoSig es el siguiente estado a estadoInicio, el cual necesitamos para calcular el tiempo
        let estadoSig = this.dataEstados[1];

        //diferencia de tiempo desde hora inicio al estado siguiente
        let dif = moment(estadoSig.read_at, "YYYY-MM-DD HH:mm:ss").diff(
          moment(this.init_date_filter, "YYYY-MM-DD HH:mm:ss"),
          "seconds"
        ); //, "YYYY-MM-DD HH:mm:ss"

        //refactor de los segundos para crear el cubo(anchura del cubo referencia a cuanto tiempo ha pasado en ese estado)
        let difRefactor = dif * refactor;

        //generamos el cubo con los datos anteriores
        // console.log("estados activos", this.estadosActivos);
        let estadoActivo = this.estadosActivos.find((estado) => estado.nombre === estadoInicio.value);
        let color = estadoActivo.checked ? this.getColor(estadoInicio.value) : "#ffffff";
        ctx.fillStyle = color; //this.getColor(estadoInicio.marcha);
        ctx.fillRect(posX, posY, difRefactor, alturaCubo);

        //guardamos la hora y el minuto donde se cambia el estado al estado i-1
        let horaInicioEstado = moment(estadoInicio.read_at).format("HH:mm:ss");
        let horaFinEstado = moment(estadoSig.read_at).format("HH:mm:ss");

        //guardar la estructura de cada cubo
        this.estados.push({
          x: posX,
          y: posY,
          width: difRefactor,
          height: alturaCubo,
          total: dif,
          horaInicio: `${horaInicioEstado}`,
          horaFin: `${horaFinEstado}`,
          estado: estadoInicio.value,
          color: this.getColor(estadoInicio.value),
        });

        //actualizacion de la posicion del siguiente cubo
        // posXAnt = posX
        posX += difRefactor;
        //creacion del resto del grafico
        // ------------------------------------------------------------------------------------------------------------------------------------------
        //recorremos el array de los estados
        // let cont = 0;
        for (let i = 1; i < this.dataEstados.length; i++) {
          //comprobamos si el estado esta activo para mostrarlo por el grafico
          // console.log(this.estadosActivos);
          estadoActivo = this.estadosActivos.find((estado) => estado.nombre === this.dataEstados[i - 1].value);
          color = estadoActivo.checked ? this.getColor(this.dataEstados[i - 1].value) : "#ffffff";

          //si el estado esta en el intervalo dado por el usuario, lo dibujamos
          if (this.comprobarHora(moment(this.dataEstados[i - 1].read_at, "YYYY-MM-DD HH:mm:ss"))) {
            //comparamos la diferencia entre horas para sacar cuantos segundos pasa en el estado i-1(xS *100)
            // let dif = 0;
            //si el estado siguiente esta en el intervalo dado, comparamos con el estado siguiente
            if (this.comprobarHora(moment(this.dataEstados[i].read_at, "YYYY-MM-DD HH:mm:ss"))) {
              dif = moment(this.dataEstados[i].read_at).diff(this.dataEstados[i - 1].read_at, "seconds");
            }
            //si no se encuentra en el intervalo, lo comparamos con la fecha final
            else {
              dif = moment(this.end_date_filter, "YYYY-MM-DD HH:mm:ss").diff(
                this.dataEstados[i - 1].read_at,
                "seconds"
              );
            }
            //escalado de los segundos para crear el cubo(anchura del cubo referencia a cuanto tiempo ha pasado en ese estado)
            difRefactor = dif * refactor;

            //generamos el cubo con los datos anteriores
            ctx.fillStyle = color; //this.getColor(this.dataEstados[i-1].marcha);
            ctx.fillRect(posX, posY, difRefactor, alturaCubo);

            //guardamos la hora y el minuto donde se cambia el estado al estado i-1
            horaInicioEstado = moment(this.dataEstados[i - 1].read_at).format("HH:mm:ss");
            horaFinEstado = moment(this.dataEstados[i].read_at).format("HH:mm:ss");

            // console.log("dibujando", this.dataEstados[i - 1]);
            // Generar eje X con las horas correspondientes
            // let posTxt = posX;
            //guardar la estructura de cada cubo
            this.estados.push({
              x: posX,
              y: posY,
              width: difRefactor,
              height: alturaCubo,
              total: dif,
              horaInicio: `${horaInicioEstado}`,
              horaFin: `${horaFinEstado}`,
              estado: this.dataEstados[i - 1].value,
              color: color, //this.getColor(this.dataEstados[i-1].marcha)
            });
            //actualizacion de la posicion del siguiente cubo
            // posXAnt = posX
            posX += difRefactor;
          }
          // }
        }
        //Estado final del grafico
        //-----------------------------------------------------------------------------------------------------------------------------------------
        // //añadimos el ultimo estado al grafico si la hora dada por el usuario es mayor a la hora de inicio del estado
        // if (moment(this.end_date_filter, "YYYY-MM-DD HH:mm:ss").isAfter(moment(this.ultimoEstado.read_at))) {
        dif = moment(this.end_date_filter, "YYYY-MM-DD HH:mm:ss").diff(
          moment(this.ultimoEstado.read_at, "YYYY-MM-DD HH:mm:ss"),
          "seconds"
        );

        estadoActivo = this.estadosActivos.find((estado) => estado.nombre === this.ultimoEstado.value);
        color = estadoActivo.checked ? this.getColor(this.ultimoEstado.value) : "#ffffff";

        difRefactor = dif * refactor;

        //generamos el cubo con los datos anteriores
        ctx.fillStyle = color; //this.getColor(this.dataEstados[i-1].marcha);
        ctx.fillRect(posX, posY, difRefactor, alturaCubo);

        //guardamos la hora y el minuto donde se cambia el estado al estado i-1
        horaInicioEstado = moment(this.ultimoEstado.read_at).format("HH:mm:ss");
        horaFinEstado = moment
          .utc(this.end_date_filter, "YYYY-MM-DD HH:mm:ss")
          .tz(moment.tz.guess())
          .format("HH:mm:ss");

        // Generar eje X con las horas correspondientes
        // let posTxt = posX;
        // this.generarEjeX(ctx, canvas, posTxt, posY, alturaCubo, this.ultimoEstado.read_at);

        //guardar la estructura de cada cubo
        this.estados.push({
          x: posX,
          y: posY,
          width: difRefactor,
          height: alturaCubo,
          total: dif,
          horaInicio: `${horaInicioEstado}`,
          horaFin: `${horaFinEstado}`,
          estado: this.ultimoEstado.value,
          color: color, //this.getColor(this.dataEstados[i-1].marcha)
        });

        //actualizacion de la posicion del siguiente cubo
        // posXAnt = posX
        posX += difRefactor;
        // }

        //creacion del eje x
        //-------------------------------------------------------------------------------------------------------------------------
        const interval = tiempoTotal / 25;
        // console.log(interval);
        let fechaInicial = moment(
          moment.utc(this.init_date_filter, "YYYY-MM-DD HH:mm:ss").tz(moment.tz.guess()).format("YYYY-MM-DD HH:mm:ss")
        );
        // console.log(fechaInicial);
        for (let i = 0; i < tiempoTotal; i += interval) {
          const difRefactor = i * refactor;
          this.generarEjeX(ctx, canvas, difRefactor, posY, alturaCubo, fechaInicial);
          // console.log(fechaInicial);
          fechaInicial.add(interval, "seconds");
        }
        //-----------------------------------------------------------------------------------------------------------------------
        //para evitar que cuando no haya datos no aparezca el eje x
        if (this.estados.length > 0) {
          this.generarEjeX(
            ctx,
            canvas,
            posX,
            posY,
            alturaCubo,
            moment.utc(this.end_date_filter, "YYYY-MM-DD HH:mm:ss").tz(moment.tz.guess()).format("YYYY-MM-DD HH:mm:ss")
          );
        }
      }

      //evento para capturar el movimiento por encima del grafico
      this.$refs.myCanvas.addEventListener("mousemove", (info) => {
        // console.log(info);
        const xMouse = info.offsetX;
        const yMouse = info.offsetY;

        let found = false;
        this.estados.forEach((componente) => {
          if (
            xMouse >= componente.x &&
            xMouse <= componente.x + componente.width &&
            yMouse >= componente.y &&
            yMouse <= componente.y + componente.height
          ) {
            found = true;
            this.updateHoverCanvas(xMouse, yMouse, componente, hoverCanvas, hoverCtx);
          }
        });
        if (!found) {
          hoverCtx.clearRect(0, 0, hoverCanvas.width, hoverCanvas.height);
        }
      });
    },
    //Funcion para generar el grafico de porcentajes
    //---------------------------------------------------------------------------------------------------------------------------
    generarGraficoPorcentajes() {
      this.porcentajes = [];
      //creamos el canvas
      const canvas = this.$refs.canvasPorcentaje;
      const ctx = canvas.getContext("2d");

      canvas.width = this.input.customized.width * 9.5 + 1000;
      canvas.height = this.input.customized.height + 100;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const hoverCanvas = this.$refs.datosCanvasPorcentaje;
      const hoverCtx = hoverCanvas.getContext("2d");

      hoverCanvas.width = canvas.width;
      hoverCanvas.height = canvas.height / 1.5;

      const alturaCubo = canvas.height / 2;

      const posY = 10;
      let posX = 0;

      const tiempoTotal = moment(this.end_date_filter).diff(this.init_date_filter, "seconds");
      // const refactor = (canvas.width - 500) / tiempoTotal;

      //creamos la estructura para guardar los datos de los porcentajes de los estados
      this.estadosActivos.forEach((estado) => {
        this.porcentajes.push({
          estado: estado.nombre,
          x: 0,
          y: posY,
          width: 0,
          height: alturaCubo,
          total: 0,
          porcentaje: 0,
        });
      });
      //para cada estado conseguimos la anchura total y el tiempo total (width y total)
      this.estados.forEach((estado) => {
        const porcentajeEstado = this.porcentajes.find((entry) => entry.estado === estado.estado);
        if (porcentajeEstado) {
          porcentajeEstado.width += estado.width;
          porcentajeEstado.total += estado.total;
        }
      });
      //ordenamos el array de porcentajes de mayor a menor
      this.porcentajes = this.porcentajes.sort((a, b) => b.width - a.width);
      //para cada estado conseguimos en que posicion se dibuja en el grafico (posX)
      this.porcentajes.forEach((estado) => {
        estado.x = posX;
        posX += estado.width;
      });

      //a partir de la estructura, cremos el grafico de porcentajes
      this.porcentajes.forEach((element) => {
        ctx.fillStyle = this.getColor(element.estado);
        ctx.fillRect(element.x, element.y, element.width, element.height);
        element.porcentaje = (element.total / tiempoTotal) * 100;
      });

      //evento para capturar el movimiento por encima del grafico
      this.$refs.canvasPorcentaje.addEventListener("mousemove", (info) => {
        // console.log(info);
        const xMouse = info.offsetX;
        const yMouse = info.offsetY;

        let found = false;
        this.porcentajes.forEach((componente) => {
          if (
            xMouse >= componente.x &&
            xMouse <= componente.x + componente.width &&
            yMouse >= componente.y &&
            yMouse <= componente.y + componente.height
          ) {
            found = true;
            this.updateHoverCanvasPorcentaje(xMouse, yMouse, componente, hoverCanvas, hoverCtx);
          }
        });
        if (!found) {
          hoverCtx.clearRect(0, 0, hoverCanvas.width, hoverCanvas.height);
        }
      });
    },
    generarLabelGraficos() {
      const canvas = this.$refs.canvasLabel;
      const ctx = canvas.getContext("2d");

      canvas.width = this.input.customized.width * 9.5 + 1000;
      canvas.height = this.input.customized.height * 9.5;

      const labelHeight = 20; // Altura del cuadrado de color
      const labelPadding = 10; // Espacio entre el cuadrado y el texto
      const labelWidth = 20; // Ancho del cuadrado de color
      const fontSize = 15; // Tamaño de la fuente

      let sep = 0; // Separación inicial
      this.estadosActivos.forEach((element, index) => {
        // Configurar el color del cuadrado
        ctx.fillStyle = this.getColor(element.nombre);
        ctx.fillRect(sep, 5, labelWidth, labelHeight); // Dibujar el cuadrado de color

        // Configurar el color y fuente del texto
        ctx.fillStyle = "black";
        ctx.font = `bold ${fontSize}px Arial`;

        // Dibujar el texto al lado del cuadrado
        //eslint-disable-next-line
        let texto = this.generarNombre(element.nombre) + ' ( '+ Math.round(this.porcentajes[index].porcentaje) + '%)'
        ctx.fillText(texto, sep + labelWidth + labelPadding, 20);

        // Ajustar la separación para el próximo label
        sep += labelWidth + labelPadding + ctx.measureText(texto).width + labelPadding;
      });
    },
    generarTituloGraficos() {
      const canvas = this.$refs.canvasTitulo;
      const ctx = canvas.getContext("2d");

      canvas.width = this.input.customized.width + 300;
      canvas.height = this.input.customized.height;

      // const labelPadding = 10; // Espacio entre el cuadrado y el texto
      // const labelWidth = 20; // Ancho del cuadrado de color
      const fontSize = 15; // Tamaño de la fuente

      // let sep = 0; // Separación inicial

      // Configurar el color y fuente del texto
      ctx.fillStyle = "black";
      ctx.font = `bold ${fontSize}px Arial`;

      // Dibujar el texto al lado del cuadrado
      ctx.fillText("RESUMEN TIEMPO TOTAL EN CADA ESTADO", 0, 20);
    },
    //funcion para calcular el tiempo total
    // calcularTiempoTotal() {
    //   let tiempoTotal = 0;
    //   for (let i = 1; i < this.dataEstados.length; i++) {
    //     //si el bloque entero esta en el intervalo sumamos el tiempo completo
    //     if (
    //       this.comprobarHora(moment(this.dataEstados[i - 1].read_at, "YYYY-MM-DD HH:mm:ss")) &&
    //       this.comprobarHora(moment(this.dataEstados[i].read_at, "YYYY-MM-DD HH:mm:ss"))
    //     ) {
    //       tiempoTotal += moment(this.dataEstados[i].read_at).diff(this.dataEstados[i - 1].read_at, "seconds");
    //     }
    //     //si el primer elemento esta en el intervalo pero el segundo esta fuera, hacemos un bloque diferente para el grafico
    //     else if (
    //       this.comprobarHora(moment(this.dataEstados[i - 1].read_at, "YYYY-MM-DD HH:mm:ss")) &&
    //       !this.comprobarHora(moment(this.dataEstados[i].read_at, "YYYY-MM-DD HH:mm:ss"))
    //     ) {
    //       tiempoTotal += moment(this.end_date_filter, "YYYY-MM-DD HH:mm:ss").diff(
    //         this.dataEstados[i - 1].read_at,
    //         "seconds"
    //       );
    //     }
    //     //si el primer elemento esta fuera del intervalo y el segundo esta dentro
    //     else if (
    //       !this.comprobarHora(moment(this.dataEstados[i - 1].read_at, "YYYY-MM-DD HH:mm:ss")) &&
    //       this.comprobarHora(moment(this.dataEstados[i].read_at, "YYYY-MM-DD HH:mm:ss"))
    //     ) {
    //       tiempoTotal += moment(this.dataEstados[i].read_at).diff(
    //         moment(this.init_date_filter, "YYYY-MM-DD HH:mm:ss"),
    //         "seconds"
    //       );
    //       if (
    //         moment(this.dataEstados[i].read_at).format("HH:mm:ss") !==
    //         moment(this.init_date_filter, "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss")
    //       ) {
    //         this.inicioFueraIntervalo = true;
    //       }
    //     }
    //     //si los dos estan fuera, no hacemos bloque
    //   }
    //   // hacemos la ultima comprobacion para el estado al final del array
    //   //guardamos el ultimo estado
    //   this.ultimoEstado = this.dataEstados[this.dataEstados.length - 1];
    //   //si la hora dada por el usuario es superior a la del inicio del ultimo estaddo...
    //   if (
    //     moment(this.end_date_filter, "YYYY-MM-DD HH:mm:ss").isAfter(
    //       moment(this.ultimoEstado.read_at, "YYYY-MM-DD HH:mm:ss")
    //     )
    //   ) {
    //     tiempoTotal += moment(this.end_date_filter, "YYYY-MM-DD HH:mm:ss").diff(
    //       moment(this.ultimoEstado.read_at, "YYYY-MM-DD HH:mm:ss"),
    //       "seconds"
    //     );
    //   }
    //   return tiempoTotal;
    // },
    //Funcion que comprueba si el elemento esta entre las horas pedidas
    //-------------------------------------------------------------------------------------------------------------------------------
    comprobarHora(fecha) {
      if (
        moment(this.init_date_filter, "YYYY-MM-DD HH:mm:ss").isBefore(fecha) &&
        moment(this.end_date_filter, "YYYY-MM-DD HH:mm:ss").isAfter(fecha)
      ) {
        // console.log("entro");
        return true;
      } else {
        // console.log("no entro");
        return false;
      }
    },
    //Funcion para comprobar si las fechas dadas por el usuario estan despues del ultimo estado
    //----------------------------------------------------------------------------------------------------------------------------------
    // comprobarCondicionEspecialFinal() {
    //   if (
    //     moment(this.dataEstados[this.dataEstados.length - 1].read_at) <=
    //       moment(this.init_date_filter, "YYYY-MM-DD HH:mm:ss") &&
    //     moment(this.dataEstados[this.dataEstados.length - 1].read_at) <=
    //       moment(this.end_date_filter, "YYYY-MM-DD HH:mm:ss")
    //   ) {
    //     return true;
    //   }
    // },
    // //Funcion para comprobar si las fechas dadas por el usuario estan antes del primer estado
    // //------------------------------------------------------------------------------------------------------------------------------------------
    // comprobarCondicionEspecialInicial() {
    //   if (
    //     moment(this.dataEstados[0].read_at) <= moment(this.init_date_filter, "YYYY-MM-DD HH:mm:ss") &&
    //     moment(this.dataEstados[0].read_at) <= moment(this.end_date_filter, "YYYY-MM-DD HH:mm:ss")
    //   ) {
    //     return true;
    //   }
    // },
    //Funcion que genera el eje X del grafico
    //-----------------------------------------------------------------------------------------------------------------------------------
    generarEjeX(ctx, canvas, posTxt, posY, alturaCubo, fecha) {
      // Guardar el estado actual del contexto
      ctx.save();
      let tamañoFuente = Math.abs(canvas.width * 0.006); /*10*/
      if (tamañoFuente < 5) {
        tamañoFuente = 0;
      }

      // Generar eje X con las horas correspondientes
      ctx.translate(posTxt, posY + alturaCubo + canvas.height * 0.04);
      ctx.rotate(Math.PI / (this.idEjeX == 1 ? 2 : 3)); // Gira 90 grados en sentido contrario a las agujas del reloj
      ctx.font = tamañoFuente + "px Arial";
      ctx.fillStyle = "black";
      ctx.fillText(
        `${this.idEjeX == 1 ? moment(fecha).format("HH:mm:ss") : moment(fecha).format("YYYY-MM-DD HH:mm:ss")}`,
        0,
        0
      );
      // Restaurar el contexto al estado guardado
      ctx.restore();
    },
    //Funcion para asignarle color al estado
    //---------------------------------------------------------------------------------------------------------------------
    generarColor(marcha) {
      switch (marcha) {
        case 1:
          return "#46ff00";
        case 2:
          return "#eaeaea";
        case 3:
          return "#ff0000";
        case 4:
          return "#0042ff";
        default:
          return "#050505";
      }
    },
    //Funcion para darle nombre al valor del estado
    //----------------------------------------------------------------------------------------------------------------------------
    generarNombre(val) {
      switch (val) {
        case 1:
          return "Automático";
        case 2:
          return "Parada";
        case 3:
          return "Alarma";
        case 4:
          return "Manual";
      }
    },
    //funcion para devolver el color correspondiente a cada estado
    //------------------------------------------------------------------------------------------------------------------------------------
    getColor(marcha) {
      return this.estadosActivos.find((obj) => obj.nombre === marcha).color;
    },
    //funcion que pasa de minutos a horas
    //-------------------------------------------------------------------------------------------------------------------------------------
    minutosAHoras(minutos) {
      // console.log(minutos);
      const horas = Math.floor(minutos / 60);
      const minutosRestantes = minutos % 60;
      const horasString = horas < 10 ? "0" + horas : horas;
      const minutosString = minutosRestantes < 10 ? "0" + minutosRestantes : minutosRestantes;
      return `${horasString}:${minutosString}`;
    },
  },
};
</script>
